var link_viewer_default = {
  "fontElementMap": "FVLIK",
  "link": "cEeqV",
  "linkInEditor": "_76O36",
  "linkInViewer": "_8GVfQ",
  "toolbarUrlContainer": "eAiCp",
  "toolbarUrl": "d3LWz",
  "toolbarUrlAnchor": "ythWO"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
